function normalize(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(normalize);
  }

  if (value && typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>)
      .filter(([, child]) => child !== undefined)
      .sort(([a], [b]) => a.localeCompare(b));
    return Object.fromEntries(entries.map(([key, child]) => [key, normalize(child)]));
  }

  return value;
}

export function stableSerialize(value: unknown): string {
  return JSON.stringify(normalize(value));
}

export async function sha256Fingerprint(value: unknown): Promise<string> {
  const encoded = new TextEncoder().encode(stableSerialize(value));
  const digest = await globalThis.crypto.subtle.digest('SHA-256', encoded);
  return [...new Uint8Array(digest)]
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

export function deterministicIndex(seed: string, modulo: number): number {
  if (!Number.isInteger(modulo) || modulo <= 0) {
    throw new RangeError('modulo must be a positive integer');
  }

  let hash = 0x811c9dc5;
  for (let index = 0; index < seed.length; index += 1) {
    hash ^= seed.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash % modulo;
}
